export const paytmConstants = {
    GET_LOAN_DETAILS_REQUEST: 'GET_LOAN_DETAILS_REQUEST',
    GET_LOAN_DETAILS_SUCCESS: 'GET_LOAN_DETAILS_SUCCESS',
    GET_LOAN_DETAILS_FAILURE: 'GET_LOAN_DETAILS_FAILURE',

    POST_INITIAL_ORDER_REQUEST: 'POST_INITIAL_ORDER_REQUEST',
    POST_INITIAL_ORDER_SUCCESS: 'POST_INITIAL_ORDER_SUCCESS',
    POST_INITIAL_ORDER_FAILURE: 'POST_INITIAL_ORDER_FAILURE',

    VALIDATE_PAYMENT_LINK_REQUEST: 'VALIDATE_PAYMENT_LINK_REQUEST',
    VALIDATE_PAYMENT_LINK_SUCCESS: 'VALIDATE_PAYMENT_LINK_SUCCESS',
    VALIDATE_PAYMENT_LINK_FAILURE: 'VALIDATE_PAYMENT_LINK_FAILURE',

    PAYTM_ERROR_CLEAR_ALL: 'PAYTM_ERROR_CLEAR_ALL',
};